import React from 'react'

const style={
    minHeight: '75px',
    color: 'white',
    background: 'black',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
}
const Footer = (props) => {
return <div style={style}>
    <small>Designed and built by Adam Woolf @ <a href='https://www.webspinner.eu'>WebSpinner.eu</a></small><br/>
    <small>Photos Nagore Iraola</small>
</div>
}

export default Footer